import * as swea from 'swea';
const InteractionManager =  swea.editor.InteractionManager;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;

class CustomBulldozeInteraction extends swea.editor.interactions.BulldozeInteraction {
  constructor(options) {
    super(options);
    this._disabledInteractionClasses = [];
  }

  initialize(element, viewerId){
    super.initialize(element, viewerId);

    // When user closes the tool
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.ESC],
      this,
      () => {
        this.terminate();
      }
    ));

    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.BACK_SPACE],
      this,
      () => {
        this.removeLastPoint();
      }
    ));
  }

  /**
   * When the interaction is initialized set the cursor.
   * @param element { DOMElement } The element that the interaction works on
   * @param viewer { scene.viewers.Viewer } The viewer
   *
   * @override
   */
  whenInitialized(element, viewerId){
    viewerId;
    this._disabledInteractionClasses = InteractionManager.instance().disableContinuousInteractions();
    InstructionServiceActions.showInstruction('instructions.create_area');
  }

  /**
   * Keeping default behaviour and re-enabling continuous interactions.
   *
   * @override
   */
  whenAreaFinished(){
    super.whenAreaFinished();
    InteractionManager.instance().enableContinuousInteractions(this._disabledInteractionClasses);
  }

  terminate() {
    super.terminate();
    InstructionServiceActions.showInstruction('instructions.add_bulldoze');
    InteractionManager.instance().enableContinuousInteractions(this._disabledInteractionClasses);
  }
}
export default CustomBulldozeInteraction;
